/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListCommentContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_story">;
    readonly " $refType": "ReplyListCommentContainer_story";
};
export type ReplyListCommentContainer_story$data = ReplyListCommentContainer_story;
export type ReplyListCommentContainer_story$key = {
    readonly " $data"?: ReplyListCommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListCommentContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '43fa314fd20ee0f8414cd846061e1472';
export default node;
